import http from "src/utils/http";

export class Processor {
  constructor(user) {
    this.user = user;
  }

  async getTemplates() {
    let { data } = await http.get(
      `/api/integrations/integration/user-integrated/get-pandadoc-templates`,
      {
        params: {
          user_id: this.user?.id,
          organization_id: this.user?.organization?.id,
        },
      }
    );

    return data;
  }
}
